import { render, staticRenderFns } from "./DossiersDataTable.vue?vue&type=template&id=5ae44220"
import script from "./DossiersDataTable.vue?vue&type=script&lang=js"
export * from "./DossiersDataTable.vue?vue&type=script&lang=js"
import style0 from "./DossiersDataTable.vue?vue&type=style&index=0&id=5ae44220&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports